import React, { useState, useEffect } from 'react';
import parse from 'html-react-parser';
import VideoModal from '../VideoModal';
import { Link } from 'react-router-dom';
import whitearrow from "../Images/whitearrow.svg"
import a3 from "../Images/a3.jpeg"

export default function Hero({
  title,
  subTitle,
  bgUrl,
  imgUrl,
  videoBtnText,
  videoUrl,
  infoList,
  btnText,
  btnUrl,
}) {
  const [visibleLetters, setVisibleLetters] = useState(0);

  // Split title into parts: every character letter-by-letter, with line break after first comma
  const parseTitle = (text) => {
    const parts = [];
    let firstCommaDone = false;
    for (let i = 0; i < text.length; i++) {
      const char = text[i];
      if (char === ',' && !firstCommaDone) {
        parts.push({ type: 'letter', content: char });
        parts.push({ type: 'linebreak', content: '' });
        firstCommaDone = true;
      } else if (char === '\n') {
        parts.push({ type: 'linebreak', content: '' });
      } else {
        parts.push({ type: 'letter', content: char });
      }
    }
    return parts;
  };

  const titleParts = parseTitle(title);

  useEffect(() => {
    const intervalTime = 60; // ms between each letter (faster reveal)
    const resetDelay = 2500; // delay before animation restarts

    const timer = setInterval(() => {
      setVisibleLetters((prev) => {
        if (prev < titleParts.length) {
          return prev + 1;
        } else {
          // Reset to 0 after a delay to restart the animation
          setTimeout(() => setVisibleLetters(0), resetDelay);
          return prev; // Keep current state until reset
        }
      });
    }, intervalTime);

    return () => clearInterval(timer);
  }, [titleParts.length]);

  const renderAnimatedTitle = () => {
    return titleParts.map((part, index) => {
      if (part.type === 'linebreak') {
        return <br key={index} />;
      }
      return (
        <span
          key={index}
          style={{
            opacity: index < visibleLetters ? 1 : 0,
            transition: 'opacity 0.12s ease-out',
            display: 'inline-block',
          }}
        >
          {part.content === ' ' ? '\u00A0' : part.content}
        </span>
      );
    });
  };

  return (
    <section className="cs_hero cs_style_1">
      <div
        className="cs_hero_wrap cs_bg_filed"
        style={{ 
          backgroundImage: `url(${bgUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'top center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="container">
          <div className="cs_hero_text">
            <h2 className="cs_hero_title cs_fs_72">{renderAnimatedTitle()}</h2>
            <p className="cs_hero_subtitle cs_fs_20 cs_heading_color">
              {parse(subTitle)}
            </p>
            {(videoBtnText || videoUrl) && (
              <div className="cs_hero_btn_wrap">
                <VideoModal
                  videoUrl={videoUrl}
                  videoBtnText={videoBtnText}
                  variant="cs_heading_color"
                />
              </div>
            )}
          </div>
          {/* <img src={a3} alt="Hero" className="cs_hero_img" /> */}
          <div className="cs_hero_info_wrap cs_shadow_1 cs_white_bg cs_radius_15">
            {infoList.map((item, index) => (
              <div className="cs_hero_info_col" key={index}>
                <div className="cs_hero_info d-flex align-items-center">
                  <div className="cs_hero_info_icon cs_center rounded-circle cs_accent_bg">
                    <img src={item.iconUrl} alt="Icon" />
                  </div>
                  <div className="cs_hero_info_right">
                    <h3 className="cs_hero_info_title cs_semibold">
                      {item.title}
                    </h3>
                    <p className="cs_hero_info_subtitle cs_fs_20">
                      {parse(item.subTitle)}
                    </p>
                  </div>
                </div>
              </div>
            ))}
            <div className="cs_hero_info_col">
              <Link to={btnUrl} className="cs_btn cs_style_1">
                <span>{btnText}</span>
                <i>
                  <img src={whitearrow} alt="Icon" />
                  <img src={whitearrow} alt="Icon" />
                </i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
